module.exports = __webpack_public_path__ + "static/media/thumbs_dsc_0489.9a69fce2.jpg";